import 'components/AdminLayout/scss/grid.scss';
import 'components/AdminLayout/scss/text-blc.scss';

import React from 'react';
window.addEventListener('error', function (event) {
	console.error('Глобальная ошибка:', event.error || event.message);
});
window.addEventListener('unhandledrejection', function (event) {
	console.error('Необработанная ошибка в промисе:', event.reason);
});

import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak, { keycloakLogout } from './config/keycloak';
import { useUnit } from 'effector-react';

import { $user } from 'models/user';
import { KeycloakTokenParsed } from 'keycloak-js';

import AppRouter from './AppRouter';
import { useNavigate } from 'react-router-dom';

const eventLogger = async (event: unknown, error: unknown) => {
	console.log('onKeycloakEvent', event, error);

	if (event === 'onTokenExpired') {
		try {
			const refreshed = await keycloak.updateToken(30);

			console.log('refreshed', refreshed);
			if (!refreshed) {
				keycloakLogout(keycloak);
			}
		} catch (e) {
			console.error('Ошибка при обновлении токена:', e);
			keycloakLogout(keycloak);
		}
	}
};

class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>> {
	state = { hasError: false, error: null };

	static getDerivedStateFromError(error: any) {
		return { hasError: true, error };
	}

	componentDidCatch(error: any, errorInfo: any) {
		console.error('Ошибка в компоненте:', error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return <div>Произошла ошибка. Пожалуйста, перезагрузите страницу.</div>;
		}
		return this.props.children;
	}
}

function App() {
	const user = useUnit($user);
	const navigate = useNavigate();

	const tokenLogger = (tokens: any) => {
		console.log('onKeycloakTokens', tokens);

		const tokenParsed: KeycloakTokenParsed = keycloak.tokenParsed!;

		console.log('APP Token Parsed:', {
			tokenParsed,
			user,
			if: tokenParsed && user && tokenParsed?.groups?.length !== user?.groups?.length,
		});

		if (tokenParsed && user && tokenParsed?.groups?.length !== user?.groups?.length) {
			const encodedRef = encodeURIComponent(location.pathname);
			navigate(`/login?ref=${encodedRef}`);
		}
	};

	console.log('App', { user });

	return (
		<ReactKeycloakProvider authClient={keycloak} onEvent={eventLogger} onTokens={tokenLogger}>
			<ErrorBoundary>
				<AppRouter />
			</ErrorBoundary>
		</ReactKeycloakProvider>
	);
}

export default App;
